








import Vue from 'vue';
import menuBox from './menuBox.vue';

export default Vue.extend({
    created() {
        window.FRSToolV3.getConfig({ page: 'index', type: 'sixFunctionMenu' }).then((res: any) => {
            this.menuList = res.result;
        });
    },
    data() {
        return {
            menuList: []
        };
    },
    components: {
        menuBox
    }
});
